const checkTagHeadlineSpaces = (id) => {
    const list = document.querySelector(`.wp-block-werbebucher-tag-headline[data-id="${id}"]`)

    if (list) {
        const separators = Array.from(list.querySelectorAll('li.separator'))

        separators.forEach(sep => {
            const prevElement = sep.previousElementSibling
            const nextElement = sep.nextSibling
            if (prevElement && nextElement) {
                sep.classList.remove('hidden')

                const top = sep.getBoundingClientRect().top
                const prevTop = prevElement.getBoundingClientRect().top
                const nextTop = nextElement.getBoundingClientRect().top

                const diffPrev = prevTop - top
                const diffNext = nextTop - top
                if (diffNext > 10 || diffNext < -10 || diffPrev > 10 || diffPrev < -10) {
                    sep.classList.add('hidden')
                }
                if ((diffNext > 10 || diffNext < -10) && (diffPrev > 10 || diffPrev < -10)) {
                    sep.style.display = 'none'
                } else {
                    sep.style.display = ''
                }
            }
        })
    }
}

export default checkTagHeadlineSpaces